export default "__VITE_ASSET__DjCDAUZJ__"